// Copyright 2020 Sorama B.V.

import { View, ViewEngineHooks } from "aurelia-framework";
// import { viewEngineHooks } from 'aurelia-binding';

export enum TimelineEntryReadableType {
    spectrumanalysis = "Spectrum analysis",
    spectrogramanalysis = "Spectrogram analysis",
    nearfieldanalysis = "Nearfield analysis",
    farfieldanalysis = "Farfield analysis",
    timeanalysis = "Time analysis",
    measurement = "Measurement",
}
// By convention, Aurelia will look for any classes of the form
// {name}ViewEngineHooks and load them as a ViewEngineHooks resource. We can
// use the @viewEngineHooks decorator instead if we want to give the class a
// different name.
export class MediaTypeViewEngineHooks implements ViewEngineHooks {
    // The `beforeBind` method is called before the ViewModel is bound to
    // the view. We want to expose the enum to the binding context so that
    // when Aurelia binds the data it will find our MediaType enum.
    beforeBind(view: View) {
        // We add the enum to the override context. This will expose the enum
        // to the view without interfering with any properties on the
        // bindingContext itself.
        view.overrideContext["TimelineEntryReadableType"] = TimelineEntryReadableType;
    }
}
